import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { BoardCollectionRequiredFieldItems } from "~/components/BoardCollection/BoardCollectionRequiredFieldItems";
import { BOARD_COLLECTION_FIELDS_LIST } from "~/constants/testIDs";
import { boardCollectionAttemptedSubmissionFormSelector, boardCollectionFieldsSelector, boardCollectionFormIsValidSelector, boardCollectionInvalidFieldsSelector } from "~/store/boardCollection/selectors";
import { useContentCollectionCustomFields } from "./hooks/useContentCollectionCustomFields";
export const BoardCollectionRequiredFields = /*#__PURE__*/ memo(()=>{
    const { data: workspaceCustomFields } = useContentCollectionCustomFields();
    const attemptedSubmission = useSelector(boardCollectionAttemptedSubmissionFormSelector);
    const isValid = useSelector(boardCollectionFormIsValidSelector);
    const invalidFields = useSelector(boardCollectionInvalidFieldsSelector);
    const _formFields = useSelector(boardCollectionFieldsSelector);
    const formFields = useMemo(()=>{
        return _formFields.filter((field)=>field.type === "description" && field.required || field.type === "custom_field").sort((fieldA, fieldB)=>fieldA.required === fieldB.required ? 0 : fieldA.required ? -1 : 1).map((field)=>{
            var _workspaceCustomFields_data_find, _workspaceCustomFields_data_find1;
            const isInvalid = !!invalidFields.find((invField)=>field.id === invField.id) && attemptedSubmission;
            return {
                ...field,
                isInvalid,
                name: field.type === "custom_field" ? workspaceCustomFields === null || workspaceCustomFields === void 0 ? void 0 : (_workspaceCustomFields_data_find = workspaceCustomFields.data.find((wsField)=>field.customFieldId === wsField.id)) === null || _workspaceCustomFields_data_find === void 0 ? void 0 : _workspaceCustomFields_data_find.name : field.type === "title" ? "Name" : "Description",
                customFieldType: workspaceCustomFields === null || workspaceCustomFields === void 0 ? void 0 : (_workspaceCustomFields_data_find1 = workspaceCustomFields.data.find((wsField)=>field.customFieldId === wsField.id)) === null || _workspaceCustomFields_data_find1 === void 0 ? void 0 : _workspaceCustomFields_data_find1.type
            };
        });
    }, [
        _formFields,
        attemptedSubmission,
        invalidFields,
        workspaceCustomFields === null || workspaceCustomFields === void 0 ? void 0 : workspaceCustomFields.data
    ]);
    if (!formFields.length) {
        return null;
    }
    const showError = attemptedSubmission && !isValid;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-[14px]",
        "data-testid": BOARD_COLLECTION_FIELDS_LIST,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-14 font-semibold text-pigeon-600",
                children: "Please provide the following details on your files:"
            }),
            showError && /*#__PURE__*/ _jsx("div", {
                className: "mt-0.5 text-12 italic text-flamingo-700",
                children: "Missing required fields"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "mt-2",
                style: {
                    paddingInlineStart: 0
                },
                children: formFields.map((field)=>/*#__PURE__*/ _jsx(BoardCollectionRequiredFieldItems, {
                        field: field
                    }, field.id))
            })
        ]
    });
});
BoardCollectionRequiredFields.displayName = "BoardCollectionRequiredFields";
